// import './lib/jquery.min';

import Cookiebar from './lib/cookies_hollerhof';

/**
 * Ready handler to support webpack hmr
 * DOMContentLoaded in browser
 *
 * @param  {Function} fn callback ob ready event
 * @return {void}
 */
const ready = (fn) => {
  if (document.readyState != 'loading') {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};

ready(() => {
  Cookiebar.init();
});

